import { render, staticRenderFns } from "./HotelSta.vue?vue&type=template&id=ca975942&scoped=true"
import script from "./HotelSta.vue?vue&type=script&lang=js"
export * from "./HotelSta.vue?vue&type=script&lang=js"
import style0 from "./HotelSta.vue?vue&type=style&index=0&id=ca975942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca975942",
  null
  
)

export default component.exports